export const COOKIE_NAMES = {
  COUNTRY: 'country',
  HAS_VISITED: 'hasVisited',
  SELECTED_PORTAL: 'selectedPortal',
};
